import { FormHelperText, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { OwnerDataCups } from "../../../../core/models/ownerData/ownerData.model";
import ConsumptionsManagementsDeliveryAddressComponent from "../../../ConsumptionsManagementsDeliveryAddressComponent/ConsumptionsManagementsDeliveryAddressComponent";
import ButtonElement from "../../../UI/ButtonElement/ButtonElement";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import theme from "../../../../muiTheme";

interface ManagementsUpdatePowersCupsSelectionProps {
  ownerDataCups: OwnerDataCups[];
  ownerDataCupSelected: OwnerDataCups;
  setOwnerDataCupSelected: React.Dispatch<React.SetStateAction<OwnerDataCups>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  cupsError: "renovation_error" | "expired" | "atr_checked" | null;
}

const ManagementsUpdatePowersCupsSelection = ({
  ownerDataCups,
  ownerDataCupSelected,
  setOwnerDataCupSelected,
  setStep,
  cupsError,
}: ManagementsUpdatePowersCupsSelectionProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Box component="div" paddingBottom={{ xs: "1.25rem", md: "2.5rem" }}>
        <Typography
          component="h3"
          variant="h3"
          paddingBottom={{ xs: "1.25rem", md: "2rem" }}
        >
          {t("Gestiones.Seleccione el CUPS")}
        </Typography>
        <Typography
          component="p"
          variant="body1"
          paddingBottom={{ xs: "0.75rem", md: "1.5rem" }}
        >
          {t(
            "Gestiones.Los cambios disponibles estarán sujetos a la tarifa contratada",
          )}
        </Typography>
        <Typography
          component="p"
          variant="body1"
          sx={{ fontWeight: 700, fontStyle: "italic" }}
        >
          {t(
            "Gestiones.Solo realizamos cambio de potencia para servicios de electricidad",
          )}
        </Typography>
      </Box>
      <Stack
        marginTop={4}
        width={{ xs: "100%", md: "25rem" }}
        paddingBottom={{ xs: "1.25rem", md: "2.5rem" }}
      >
        <ConsumptionsManagementsDeliveryAddressComponent
          ownerDataCups={ownerDataCups}
          ownerDataCupSelected={ownerDataCupSelected}
          setOwnerDataCupSelected={(ownerDataCupSelected: OwnerDataCups) =>
            setOwnerDataCupSelected(ownerDataCupSelected)
          }
          excludeGas={true}
        />
      </Stack>
      {!!cupsError && (
        <FormHelperText
          error
          sx={{
            marginLeft: 0,
            color: theme.palette.error.main,
          }}
        >
          <span className="t-icon-CGU" />{" "}
          {t(`Gestiones.Errores CUPS cambio de potencias.${cupsError}`)}
        </FormHelperText>
      )}
      <Box
        marginTop={4}
        component="div"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className="management-update-new-contact__actions"
        sx={{ flexDirection: { xs: "column", md: "row" } }}
      >
        <ButtonElement
          disabled={!!!ownerDataCupSelected.codeCups.length || !!cupsError}
          onClick={() => setStep(0)}
        >
          {t("Gestiones.Seleccionar CUPS")}
        </ButtonElement>
        <ButtonElement
          onClick={() => {
            navigate(process.env.REACT_APP_MANAGEMENT!);
          }}
          secondary
        >
          {t("Cancelar")}
        </ButtonElement>
      </Box>
    </>
  );
};

export default ManagementsUpdatePowersCupsSelection;
